<template>
    <div class="log-detail-wrapper">
        <div class="log-detail">
            <div class="log-detail-bar">
                <ul class="overview">
                    <li v-for="(item, index) in briefData" :key="index">{{ item.key }}: {{ item.value }}</li>
                </ul>
                <Select initValue="" :options="operateOptions" class="status-select" @menuClick="optionChange"></Select>
                <LangSelect :value="initLang" class="lang-select" @change="langChange"></LangSelect>
            </div>
            <Table class="log-detail-table" :config="tableConfig" :dataset="tableData" :total="totalNumber" @pageChange="pageChange" />
        </div>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Table from "@/views/zhiji/bComponents/table/Table";
import LangSelect from "@/components/langSelect";
import { operateOptions, logDetailsTableConfig } from "../../clusterPageConfig.js";
import i18n from "@/i18n";

export default {
    name: "OperationLog",
    components: {
        Select,
        Table,
        LangSelect
    },
    data() {
        return {
            tableData: [],
            totalNumber: 0,
            curPage: 1,
            curPageLen: 10,
            status: "",
            briefData: [],
            initLang: "en"
        };
    },
    computed: {
        tableConfig() {
            return logDetailsTableConfig();
        },
        operateOptions() {
            return operateOptions();
        }
    },
    watch: {
        tableConfig() {
            this.queryLogDetail();
        }
    },
    methods: {
        queryLogDetail() {
            let reqData = {
                page: this.curPage,
                size: this.curPageLen,
                status: this.status,
                lang: this.initLang
            };
            this.zhiji.requestByServiceName("queryLogDetail", reqData).then(res => {
                this.totalNumber = res.total;
                this.briefData = res.briefData;
                this.tableData = res.tableData;
                this.tableConfig.columns[1].header = `${i18n.t("zhiji.cluster.logDetail.question")}( ${res.currentCount} )`;
                if (res.currentCount == 0) {
                    this.tableConfig.isHideFooter = true;
                }
            });
        },
        optionChange(data) {
            this.status = data.value;
            this.queryLogDetail();
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.queryLogDetail();
        },
        langChange(data) {
            this.curPage = 1;
            this.initLang = data === "all" ? "" : data;
            this.queryLogDetail();
        }
    },
    mounted() {
        this.queryLogDetail();
    }
};
</script>

<style scoped lang="scss">
.log-detail-wrapper {
    .bread-crumb {
        padding: 16px 40px 0;
    }

    .log-detail {
        background: #fff;
        padding: 0 16px 24px 24px;
        border: 1px solid #d9e4ef;
        margin: 16px 16px 16px 16px;
        border-radius: 4px;

        .log-detail-bar {
            display: flex;
            align-items: center;
            padding: 16px 0;

            .overview {
                float: left;

                li {
                    display: inline-block;
                    color: #41475e;
                    font-weight: bold;
                    margin-right: 32px;
                }
            }

            .status-select {
                float: right;
                width: 160px;
                margin-left: 18px;
                padding-left: 10px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
            }
        }

        .log-detail-table {
            border-width: 0 1px 1px 1px;
            border-style: solid;
            border-color: hsl(210, 47%, 93%);
        }
    }
}
</style>
